import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const SessionExpiredModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLoginRedirect = () => {
    onClose();
    // navigate('/login');
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: 'none' }}>
            <h6 className="text-lg font-semibold text-primary dark:text-white transition-colors duration-200 m-0 text-uppercase mt-2">
              Session Expired
            </h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Your session has expired. Please log in again to continue.</p>
          </div>
          <div className="modal-footer" style={{ borderTop: 'none' }}>
            <Button color="primary" onClick={handleLoginRedirect}>
              Go to Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SessionExpiredModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SessionExpiredModal;